import { esc } from "./toast";

function inlineMarkdown(text: string): string {
  let s = esc(text);
  s = s.replace(/`([^`\n]+)`/g, "<code>$1</code>");
  s = s.replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>");
  s = s.replace(/(?<!\*)\*([^*\n]+)\*(?!\*)/g, "<em>$1</em>");
  return s;
}

export function renderMarkdown(text: string): string {
  const source = String(text ?? "").trimEnd();
  if (!source) {
    return "";
  }

  const lines = source.split(/\r?\n/);
  const parts: string[] = [];
  let listLines: string[] = [];

  const flushList = (): void => {
    if (!listLines.length) {
      return;
    }
    parts.push(
      `<ul>${listLines.map((item) => `<li>${inlineMarkdown(item)}</li>`).join("")}</ul>`,
    );
    listLines = [];
  };

  for (const line of lines) {
    const trimmed = line.trim();
    const listMatch = trimmed.match(/^[-*]\s+(.+)$/);
    if (listMatch) {
      listLines.push(listMatch[1]);
      continue;
    }
    flushList();
    if (!trimmed) {
      continue;
    }
    parts.push(`<p>${inlineMarkdown(trimmed)}</p>`);
  }
  flushList();

  return parts.join("");
}

export function setMarkdownContent(el: HTMLElement, text: string): void {
  el.innerHTML = renderMarkdown(text);
}
